import { z } from 'zod';
// ─── Questionnaire Validation ───────────────────────────────────────────────
export const questionnaireQuestionTypeSchema = z.enum([
    'TEXT',
    'LONG_TEXT',
    'NUMBER',
    'YES_NO',
    'SINGLE_CHOICE',
    'TIME',
    'DATE',
    'ADDRESS',
    'VENDOR',
    'CONTACT',
]);
export const questionnaireDataLinkSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('EVENT_FIELD'), field: z.enum(['startAt', 'venue', 'guestCount']) }),
    z.object({ kind: z.literal('EVENT_TAG'), tagCode: z.string().min(1).max(100) }),
    z.object({
        kind: z.literal('TIMELINE_TIME'),
        entryTitleMatch: z.string().min(1).max(255),
        sectionName: z.string().max(255).optional(),
    }),
    z.object({ kind: z.literal('VENDOR_LINK'), vendorCategory: z.string().max(255).optional() }),
]);
export const questionnaireQuestionConfigSchema = z.object({
    choices: z.array(z.string().max(500)).max(50).optional(),
    allowOther: z.boolean().optional(),
    placeholder: z.string().max(255).optional(),
});
export const questionnaireAnswerValueSchema = z.object({
    text: z.string().max(5000).optional(),
    number: z.number().finite().optional(),
    bool: z.boolean().optional(),
    choice: z.string().max(500).optional(),
    otherText: z.string().max(1000).optional(),
    time: z.string().max(50).optional(),
    date: z.string().max(50).optional(),
    contactName: z.string().max(255).optional(),
    contactPhone: z.string().max(50).optional(),
    vendorName: z.string().max(255).optional(),
});
export const createQuestionnaireQuestionSchema = z.object({
    prompt: z.string().min(1).max(1000),
    helpText: z.string().max(2000).optional(),
    questionType: questionnaireQuestionTypeSchema,
    isRequired: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
    config: questionnaireQuestionConfigSchema.optional(),
    dataLink: questionnaireDataLinkSchema.nullable().optional(),
    timelineEntryId: z.string().uuid().nullable().optional(),
});
export const updateQuestionnaireQuestionSchema = z.object({
    prompt: z.string().min(1).max(1000).optional(),
    helpText: z.string().max(2000).nullable().optional(),
    questionType: questionnaireQuestionTypeSchema.optional(),
    isRequired: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
    config: questionnaireQuestionConfigSchema.optional(),
    dataLink: questionnaireDataLinkSchema.nullable().optional(),
    timelineEntryId: z.string().uuid().nullable().optional(),
});
export const createQuestionnaireSectionSchema = z.object({
    name: z.string().min(1).max(255),
    description: z.string().max(2000).optional(),
    sortOrder: z.number().int().optional(),
    questions: z.array(createQuestionnaireQuestionSchema).optional(),
});
export const updateQuestionnaireSectionSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const createQuestionnaireSchema = z.object({
    eventId: z.string().uuid().optional(),
    isTemplate: z.boolean().optional(),
    templateName: z.string().max(255).optional(),
    title: z.string().min(1).max(500),
    description: z.string().max(5000).optional(),
    eventTypeId: z.string().uuid().nullable().optional(),
    timelineTemplateId: z.string().uuid().nullable().optional(),
    sections: z.array(createQuestionnaireSectionSchema).optional(),
});
export const updateQuestionnaireSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    templateName: z.string().max(255).nullable().optional(),
    description: z.string().max(5000).nullable().optional(),
    status: z.enum(['DRAFT', 'SENT', 'IN_PROGRESS', 'SUBMITTED', 'REVIEWED']).optional(),
    isArchived: z.boolean().optional(),
    eventTypeId: z.string().uuid().nullable().optional(),
    timelineTemplateId: z.string().uuid().nullable().optional(),
});
export const cloneQuestionnaireSchema = z.object({
    eventId: z.string().uuid(),
    title: z.string().min(1).max(500).optional(),
});
export const saveQuestionnaireAsTemplateSchema = z.object({
    templateName: z.string().min(1).max(255),
});
export const sendQuestionnaireLinkSchema = z.object({
    email: z.string().email().optional(),
});
export const saveQuestionnaireAnswerSchema = z.object({
    value: questionnaireAnswerValueSchema,
    vendorId: z.string().uuid().nullable().optional(),
    clientTimezone: z.string().max(100).optional(),
});
export const submitQuestionnaireSchema = z.object({
    clientTimezone: z.string().max(100).optional(),
});
//# sourceMappingURL=questionnaire.js.map